import React from 'react'
import { Card as BCard } from 'react-bootstrap'
import { ClipLoader } from 'react-spinners'


export function Card(props){
  const { headerButtons=[], title, subtitle, isLoading, className, visible=true } = props

  return(
    <BCard className={`${className ? className : ''}${!visible ? 'd-none' : ''}`} >
      <BCard.Header className="d-flex align-items-center justify-content-between">
        <div>
          <div className="font-weight-bold">{title}</div>
          <div className="text-secondary">{subtitle}</div>
        </div>
        <div className="d-flex align-items-start">
          <div className="d-lg-flex justify-content-center align-items-start text-right">
            {headerButtons.map((buttoned,index)=>(
              <button 
                key={index}
                onClick={buttoned.handleClick} 
                className="btn btn-primary ml-3 mt-1 d-block">{buttoned.label}</button>
            ))}
          </div>
        </div>
      </BCard.Header>
      <BCard.Body className="d-flex justify-content-around p-3">
        { isLoading ?
          <ClipLoader/> :
          props.children
        }
      </BCard.Body>
    </BCard>
  )
}